<template>
    <div class="value">
        <MainMenu 
        :banner="navData.banner.value_banner" 
        :mobileBanner="navData.banner.web_value_banner" 
        :menu="menu"/>
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MainMenu from '../../components/mainMenu.vue';
export default {
    name: "value",
    data() {
        return {
            menu: [
                { text: 'ESG', link: '/value/esg' },
                { text: '企业发展需求', link: '/value/edn' },
                { text: '办公社群服务', link: '/value/community' },
            ]
        };
    },
    computed: {
        ...mapState(['navData'])
    },
    components: {
        MainMenu
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.value{
    overflow-x: hidden;
    line-height: 1.8;
}
</style>